import { render, staticRenderFns } from "./SearchRegistrationNumber.vue?vue&type=template&id=b49489da"
import script from "./SearchRegistrationNumber.vue?vue&type=script&lang=js"
export * from "./SearchRegistrationNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports